import http from '../../services/http-common';

class BudgetItemInfoService {
    
    getBudgetItemInfoForList() {
    return http.get(`/BudgetItemInfo/sp/list`);
    }
    insert(data) {
        return http.post(`/BudgetItemInfo/db/add`,data);
    }
    update(data) {
        return http.put(`/BudgetItemInfo/db/update`,data);
    }
}

export default new BudgetItemInfoService();